export default __webpack_public_path__ + "static/media/noimage.00b30a0e.png";